import { Star } from "lucide-react";
import { useLang, UI } from "@/lib/content";

export default function Marquee() {
  const { lang } = useLang();
  const items = UI.marquee[lang] || UI.marquee.es;
  return (
    <div data-testid="marquee-band" className="border-y border-brass/25 bg-navy py-5 text-paper">
      <div className="marquee-mask">
        <div className="marquee-track animate-marquee">
          {[0, 1].map((copy) => (
            <div key={copy} aria-hidden={copy === 1} className="flex shrink-0 items-center">
              {items.map((item, i) => (
                <span key={`${copy}-${i}`} className="flex items-center">
                  <span className="whitespace-nowrap font-display text-lg font-medium tracking-wide sm:text-xl">{item}</span>
                  <Star size={13} className="mx-8 shrink-0 fill-brass text-brass" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
